import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { Container } from '@chakra-ui/react';

import { RECRUIT_PATH_PREFIX } from 'common/constants';

import Layout from 'common/components/Layout/Layout';
import Spinner from 'common/components/Spinner/Spinner';

export default function RecruitJobsIndex() {
  const router = useRouter();

  useEffect(() => {
    // Redirect to London page.
    router.replace(`${RECRUIT_PATH_PREFIX}/jobs/london/`);
  }, []);

  return (
    <Layout
      pageTitle="Cleaning Jobs in London | Become a Housekeep Pro"
      description="We’re Housekeep, London’s best cleaning agency. We make it easy for customers to find experienced cleaners in their local area &amp; help cleaners to earn more money. We’re growing fast, with 1000s of customers in all areas of London - so cleaners earn more with us than any other agency."
      showStatusBar={false}
      nav="recruit"
    >
      <Container maxW="container.lg" py={12}>
        <Spinner />
      </Container>
    </Layout>
  );
}
